var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "template3wrapper" }, [
    _c("h2", [_vm._v(_vm._s(_vm.question.title))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.question.subTitle))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "answersWrapper" },
      _vm._l(this.answers, function (answer) {
        return _c(
          "div",
          {
            key: answer.id,
            staticClass: "answerItem",
            class: [
              answer.selected ? "selected" : "",
              answer.disabled ? "disabled" : "",
            ],
            attrs: { title: answer.text },
            on: {
              click: function ($event) {
                return _vm.selectAnswer(answer.id)
              },
            },
          },
          [
            _c("div", { staticClass: "answerImage osf-q3-framed-image" }, [
              _c("div", { staticClass: "selector" }, [
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !answer.disabled,
                      expression: "!answer.disabled",
                    },
                  ],
                  attrs: { src: _vm.images.checkmark },
                }),
              ]),
              _vm._v(" "),
              _c("img", { attrs: { src: _vm.getAnswerImage(answer) } }),
            ]),
            _vm._v(" "),
            _c("h5", [_vm._v(_vm._s(answer.title))]),
            _vm._v(" "),
            _c("h6", [_vm._v(_vm._s(answer.subTitle))]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }